<template>
    <div
        style="display: contents;"
    >
        <tr
            class="kgr-table__row"
            :class="{'is-striped': isStriped}"
        >
            <td
                class="kgr-table__cell"
                colspan="5"
            >
                <div
                    class="kgr-text--truncated kgr-text--bold"
                    style="max-width: 400px"
                >
                    {{ relation.dog.name }}
                </div>
            </td>
        </tr>
        <kgr-file-table-tree
            v-for="node in relation.nodes"
            :key="node.id"
            :node="node"
            :active-nodes="activeNodes"
            :level="1"
            :is-striped="!isStriped"
            @addActive="$emit('addActive', $event)"
            @removeActive="$emit('removeActive', $event)"
        />
    </div>
</template>

<script>
import DogMemberRelation from '../../../js/dto/DogMemberRelation.js';
import FileTableTree from './FileTableTree.vue'
export default {
    components: {
        'kgr-file-table-tree': FileTableTree,
    },
    props: {
        relation: {
            type: DogMemberRelation,
            required: true,
        },
        activeNodes: {
            type: Array,
            required: true,
        },
        isStriped: {
            type: Boolean,
            required: false,
            default: false
        },
    },
}
</script>
